var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header"},[_c('div',{staticClass:"page-header__container"},[_c('div',{staticClass:"page-header__title",attrs:{"data-test":"page-header__title"}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }